import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorModalContent } from './+model/error-modal-content';

@Component({
    selector: 'ngf-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorModalComponent {

  currentDate: Date = new Date();

  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorModalContent) {}
}
